export enum Status {
    Active = 1,
    InActive = 0,
}
